import * as zod from 'zod';

const IpConfig = zod.object({
  ipAddress: zod.string(),
  subnetMask: zod.string(),
  routerAddress: zod.string(),
});

export type IpConfig = zod.infer<typeof IpConfig>;

export const NetworkConfigRequest = zod.discriminatedUnion('action', [
  zod.object({
    action: zod.literal('connectWifi'),
    ssid: zod.string().min(1),
    password: zod.string().optional(),
    hidden: zod.boolean().optional(),
    ipConfig: IpConfig.optional(),
    macAddress: zod.string().optional(),
    pin: zod.string().optional(),
  }),
  zod.object({
    action: zod.literal('connectEthernet'),
    ipConfig: IpConfig.optional(),
    macAddress: zod.string().optional(),
    pin: zod.string().optional(),
  }),
  zod.object({
    action: zod.literal('disconnectWifi'),
    pin: zod.string().optional(),
  }),
  zod.object({
    action: zod.literal('disconnectEthernet'),
    pin: zod.string().optional(),
  }),
  zod.object({
    action: zod.literal('scanWifi'),
  }),
  zod.object({
    action: zod.literal('enableWifi'),
  }),
  zod.object({
    action: zod.literal('setPIN'),
    newPIN: zod.string().min(1),
    pin: zod.string().optional(),
  }),
  zod.object({
    action: zod.literal('setName'),
    newName: zod.string().min(1),
    pin: zod.string().optional(),
  }),
  zod.object({
    action: zod.literal('validatePIN'),
    pin: zod.string().min(1),
  }),
]);

export type NetworkConfigRequest = zod.infer<typeof NetworkConfigRequest>;

export const NetworkStatus = zod.object({
  status: zod.object({
    ethernet: zod
      .object({
        IPV4: zod.string(),
        subnetMask: zod.string().optional(),
        gateway: zod.string().optional(),
        dns: zod.string().optional(),
        ipMethod: zod.enum(['auto', 'manual']).optional(),
      })
      .nullable(),
    wifi: zod
      .object({
        SSID: zod.string(),
        IPV4: zod.string().optional(),
        subnetMask: zod.string().optional(),
        gateway: zod.string().optional(),
        dns: zod.string().optional(),
        ipMethod: zod.enum(['auto', 'manual']).optional(),
      })
      .nullable(),
    direct: zod.object({ IPV4: zod.string() }).nullable(),
    errors: zod.array(zod.string()),
  }),
  availableNetworks: zod.array(zod.string()),
  wifiEnabled: zod.boolean(),
  isPINEstablished: zod.boolean(),
});

export type NetworkStatus = zod.infer<typeof NetworkStatus>;
